import React, { useEffect, useRef } from 'react'

function Marquee({ items, reverse = false, speed = 40 }) {
  const trackRef = useRef(null)
  const copyRef = useRef(null)
  const posRef = useRef(0)

  useEffect(() => {
    const track = trackRef.current
    const copy = copyRef.current
    if (!track || !copy) return

    let frame
    let lastTime = null
    let initialized = false

    const step = now => {
      if (lastTime === null) lastTime = now
      const dt = Math.min((now - lastTime) / 1000, 0.05)
      lastTime = now

      const copyWidth = copy.offsetWidth
      if (copyWidth > 0) {
        if (!initialized) {
          posRef.current = reverse ? -copyWidth : 0
          initialized = true
        }

        if (reverse) {
          posRef.current += speed * dt
          if (posRef.current >= 0) posRef.current -= copyWidth
        } else {
          posRef.current -= speed * dt
          if (posRef.current <= -copyWidth) posRef.current += copyWidth
        }

        track.style.transform = `translateX(${posRef.current}px)`
      }

      frame = requestAnimationFrame(step)
    }

    frame = requestAnimationFrame(step)
    return () => cancelAnimationFrame(frame)
  }, [reverse, speed])

  return (
    <div
      className='relative overflow-hidden'
      style={{
        WebkitMaskImage: 'linear-gradient(90deg, transparent 0%, black 8%, black 92%, transparent 100%)',
        maskImage: 'linear-gradient(90deg, transparent 0%, black 8%, black 92%, transparent 100%)',
      }}
    >
      <div ref={trackRef} className='flex w-max items-center whitespace-nowrap will-change-transform'>
        <div ref={copyRef} className='flex flex-shrink-0 items-center gap-16 pr-16'>
          {items.map((client, index) => (
            <span
              key={`a-${client}-${index}`}
              className='flex-shrink-0 text-xl font-bold uppercase tracking-wide text-dorac-ink/25 transition-colors hover:text-dorac-purple md:text-2xl'
            >
              {client}
            </span>
          ))}
        </div>
        <div className='flex flex-shrink-0 items-center gap-16 pr-16' aria-hidden='true'>
          {items.map((client, index) => (
            <span
              key={`b-${client}-${index}`}
              className='flex-shrink-0 text-xl font-bold uppercase tracking-wide text-dorac-ink/25 transition-colors hover:text-dorac-purple md:text-2xl'
            >
              {client}
            </span>
          ))}
        </div>
      </div>
    </div>
  )
}

export default Marquee
